import { useIntl } from 'react-intl';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Logo } from '@rossum/ui';
import { Button, Stack, Typography } from '@rossum/ui/material';

const IntroScreen = () => {
  const { state = {} } = useLocation<{ redirectUrl?: string }>();

  const intl = useIntl();

  const redirectUrl = state.redirectUrl || '/';

  return (
    <Stack spacing={4} sx={{ justifySelf: 'center', maxWidth: 300, pt: 3 }}>
      <Stack
        spacing={2}
        sx={{ justifyContent: 'center', alignItems: 'center', py: 1 }}
      >
        <Logo />
        <Typography variant="h4">
          {intl.formatMessage({ id: 'containers.introScreen.welcome' })}
        </Typography>
      </Stack>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          textAlign: 'center',
        }}
      >
        {intl.formatMessage({ id: 'containers.introScreen.disclaimer' })}
      </Typography>
      <Button
        component={RouterLink}
        to={redirectUrl}
        variant="contained"
        size="large"
        data-cy="mobile-intro-button"
        sx={{ width: '100%' }}
      >
        {intl.formatMessage({ id: 'containers.introScreen.gotoapp' })}
      </Button>
    </Stack>
  );
};

export default IntroScreen;
